import React from 'react';
import styled from '@emotion/styled';
import { Dialog, type DialogProps } from '@mui/material';
import tailwindColors from '@bbkShared/tailwind.colors';

export const DialogTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: rgba(0, 0, 0, 0.8);
  padding: 0.7rem 1rem;
`;

export const DialogContent = styled.div`
  padding: 1rem;
`;

export const DialogContentBold = styled.div`
  padding: 1rem;
  font-weight: bold;
`;

export const DialogError = styled.div`
  padding: 1rem;
  color: rgb(192, 40, 40);
  word-break: break-all;
`;

export const DialogSaveStep = styled.div`
  padding: 1rem;
  color: ${tailwindColors.cbrprimary['600']};
`;

export const DialogActions = styled.div`
  padding: 1rem;

  button {
    margin-right: 0.5rem;
  }
`;

export const WrappedDialog = (props: DialogProps) => (
  <Dialog
    {...props}
    PaperProps={{
      sx: {
        borderRadius: '20px',
        background: '#F6F8FB',
      },
    }}
    sx={{
      backdropFilter: 'none',
    }}
  />
);

export const ConfirmationDialog: React.FC<DialogProps> = (props) => (
  <WrappedDialog
    maxWidth="xs"
    aria-labelledby="brightback-confirmation-dialog"
    fullWidth
    className="bbk-confirmation-dialog"
    {...props}
  />
);
